import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy</h1>
      <p>Effective Date: March 19, 2025</p>

      <p>
        <strong>Amman Sweets</strong> ("we", "our", or "us") is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you visit our website or use our services.
      </p>

      <h3>1. Information We Collect</h3>
      <ul>
        <li><strong>Personal Information:</strong> Name, email address, phone number, and delivery address provided during order placement or registration.</li>
        <li><strong>Payment Information:</strong> Payment details are securely processed through trusted third-party payment gateways.</li>
        <li><strong>Usage Data:</strong> Information on how you use our website, including cookies and analytics data.</li>
      </ul>

      <h3>2. How We Use Your Information</h3>
      <ul>
        <li>To process your orders and deliver products.</li>
        <li>To provide customer support and respond to your queries.</li>
        <li>To improve our website, services, and customer experience.</li>
        <li>To send order updates, promotions, or important notifications (only if you agree).</li>
      </ul>

      <h3>3. Sharing Your Information</h3>
      <p>
        We do not sell, trade, or rent your personal information. Your data is only shared with third-party services necessary for payment processing and delivery.
      </p>

      <h3>4. Cookies</h3>
      <p>
        Our website uses cookies to enhance user experience, analyze website traffic, and improve our services. You can control cookie preferences in your browser settings.
      </p>

      <h3>5. Data Security</h3>
      <p>
        We take reasonable steps to protect your personal information from unauthorized access, use, or disclosure.
      </p>

      <h3>6. Your Rights</h3>
      <p>
        You can update, correct, or request the deletion of your personal information by contacting us at <strong>ammansweets@gmail.com</strong>.
      </p>

      <h3>7. Changes to This Privacy Policy</h3>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be posted on this page with the updated effective date.
      </p>

      <h3>8. Contact Us</h3>
      <p>
        If you have any questions about this Privacy Policy, please contact us at:<br />
        📧 <strong>ammansweets@gmail.com</strong>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
